import * as ReactDOMNS from 'react-dom/index';

export * from 'react-dom/index';

const fallbackFindDOMNode = (node) => {
    const getDocumentFallbackNode = () => {
        if (typeof document === 'undefined') {
            return null;
        }
        return document.body || document.documentElement || null;
    };

    if (!node) {
        return getDocumentFallbackNode();
    }

    if (node.nodeType) {
        return node;
    }

    if (node.current && node.current.nodeType) {
        return node.current;
    }

    if (node.stateNode && node.stateNode.nodeType) {
        return node.stateNode;
    }

    const {
        '_reactInternals': reactInternals,
        '_reactInternalFiber': reactInternalFiber,
    } = node;
    const fiber = reactInternals || reactInternalFiber;

    if (fiber) {
        const stack = [ fiber ];
        while (stack.length) {
            const current = stack.pop();
            if (current) {
                if ((current.tag === 5 || current.tag === 6) && current.stateNode && current.stateNode.nodeType) {
                    return current.stateNode;
                }

                if (current.sibling) {
                    stack.push(current.sibling);
                }
                if (current.child) {
                    stack.push(current.child);
                }
            }
        }
    }

    return getDocumentFallbackNode();
};

const ReactDOMCompat = {
    ...ReactDOMNS,
    findDOMNode: ReactDOMNS.findDOMNode || fallbackFindDOMNode,
};

export const { findDOMNode } = ReactDOMCompat;
export default ReactDOMCompat;
